const webProjectList = [
    {
      title: 'Thesis : VR Greatest Maling Adventure ',
      date: 2019,
      link: 'https://youtu.be/tGQCwWL28jU',
      show:false,
      imgList: [
        { img: require('../img/project/vr_maling/VR_youtube.jpg') },
        { img: require('../img/project/vr_maling/VR_immersive_UI.jpg') },
        { img: require('../img/project/vr_maling/VR_Room_Escape2.jpg') },
        { img: require('../img/project/vr_maling/VR_zshooter.jpg') },
        { img: require('../img/project/vr_maling/VR_runner.jpg') },
        {img:require("../img/project/vr_maling/VR_enemydetection.jpg")},
        {img:require("../img/project/vr_maling/VR_gamedesign_zshooter.jpg")},
      ],
      caption: '4 Game in 1 Mobile VR Game',
    },
    {
      title: 'InDesign : Interior Designer',
      date: 2022,
      link: 'https://ingdesign.netlify.app',
      show:true,
      imgList: [
        { img: require('../img/project/ingdesign/mainmiddle.webp') },
        { img: require('../img/project/ingdesign/main.webp') },
        { img: require('../img/project/ingdesign/mainfooter.webp') },
        { img: require('../img/project/ingdesign/project1.webp') },
        { img: require('../img/project/ingdesign/project2.webp') },
        { img: require('../img/project/ingdesign/project3.webp') },
      ],
  
      caption: 'InDesign : Interior Designer ',
    },
    {
      title: 'SNP Indonesia : Supplies & Service for Oil Industry',
      date: 2022,
      link: 'https://snpproject.netlify.app/',
      show:true,
      imgList: [
        { img: require('../img/project/snpi/snpi.webp') },
        { img: require('../img/project/snpi/snpi2.webp') },
        { img: require('../img/project/snpi/snpi3.webp') },
      ],
      caption: 'Supplies & Service for Oil Industry, PT.SNP Indonesia website',
    },
    {
      title: 'Masa ke masa: Sebuah Perjalanan (2022-2025)',
      date: 2022,
      link: 'https://masakemasa.id',
      show:true,
      imgList: [
        { img: require('../img/project/masa/masa1main.webp') },
        { img: require('../img/project/masa/masa1footer.webp') },
        { img: require('../img/project/masa/masa-menu.webp') },
        { img: require('../img/project/masa/masa-about.webp') },
        { img: require('../img/project/masa/masa-wedses.webp') },
        { img: require('../img/project/masa/masa-wedses-detail.webp') },
      ],
      caption: 'Wedding Photographer Website ',
    },
        {
      title: 'MASA Admin Website',
      date: 2023,
      link: '',
      show:true,
      imgList: [
        { img: require('../img/project/masafirebase/masafirebase1.webp') },
        { img: require('../img/project/masafirebase/masafirebase2.webp') },
        { img: require('../img/project/masafirebase/masafirebase3.webp') },
        { img: require('../img/project/masafirebase/masafirebase4.webp') },
        { img: require('../img/project/masafirebase/masafirebase5.webp') },
        { img: require('../img/project/masafirebase/masafirebase6.webp') },
      ],
      caption: 'Masa Admin with Firebase',
    },

    {
      title: 'SanGallery: Classic Movie Gallery',
      date: 2023,
      link: 'https://sangallery.netlify.app',
      show:false,
      imgList: [
        { img: require('../img/project/sangallery/1.webp') },
        { img: require('../img/project/sangallery/2.webp') },
        { img: require('../img/project/sangallery/3.webp') },
      ],
      caption: 'SanGallery : Classic Movie Gallery',
    },
    {
      title: 'JC Dental ',
      date: 2023,
      link: 'https://jcdental.netlify.app',
      imgList: [
        { img: require('../img/project/snpi/snpi.webp') },
      ],
      caption: 'Dental Clinic Website',
    },
    {
      title: 'Vyf Coffee',
      date: 2023,
      link: '',
      show:false,
      imgList: [
        { img: require('../img/project/snpi/snpi.webp') },
      ],
      caption: 'Coffee Website',
    },

    {
      title: 'BBJ Cargo Administration and Management Website',
      date: 2025,
      link: '',
      show:false,
      // imgList: [
      //   { img: require('../img/project/bbjcargo/1.webp') },
      //   { img: require('../img/project/bbjcargo/2.webp') },
      //   { img: require('../img/project/bbjcargo/3.webp') },
      //   { img: require('../img/project/bbjcargo/4.webp') },
      //   { img: require('../img/project/bbjcargo/5.webp') },
      //   { img: require('../img/project/bbjcargo/6.webp') },
      // ],
      caption: 'BackEnd BBJ Website',
    },
    {
      title: 'BBJ Cargo | Reliable Logistics & Import Solutions',
      date: 2025,
      link: '',
      // link:"https://bbjcargo.id/",
      show:true,
      imgList: [
        { img: require('../img/project/bbjcargo/1.webp') },
        { img: require('../img/project/bbjcargo/2.webp') },
        { img: require('../img/project/bbjcargo/3.webp') },
        { img: require('../img/project/bbjcargo/4.webp') },
        { img: require('../img/project/bbjcargo/5.webp') },
        { img: require('../img/project/bbjcargo/6.webp') },
      ],
      caption: 'Jasa Pengiriman Barang Impor China-Indonesia Website',
    },

    {
      title: 'Servicing Agent Website',
      date: 2025,
      link: 'albertwithpru.com',
      show:true,
      imgList: [
        { img: require('../img/project/albertwithpru/1.webp') },
        { img: require('../img/project/albertwithpru/2.webp') },
        { img: require('../img/project/albertwithpru/3.webp') },
      ],
    },

  ]

  export default webProjectList;